module.exports = __webpack_public_path__ + "static/img/student_2.f0483040.png";